export default "__VITE_ASSET__BIA6_Cs6__"